import { TextFormatter } from './text-formatter';

const URL_PATTERN = /https?:\/\/[^\s<]+/g;
const URL_TRAILING_PATTERN = /[*_~.,;:!?)]+$/;
const LINK_PLACEHOLDER_PATTERN = /\uE000(\d+)\uE000/g;

/**
 * Converts text saved by the admin SimpleTextEditor (**bold**, *italic*, _underline_, ~strike~,
 * line breaks, blank line = new paragraph) into HTML that is safe to render with v-html.
 * Plain URLs become links. Markers are expected to be closed within a single line.
 * @param {string} text - Text with editor markers.
 * @returns {string} Escaped HTML string.
 */
export const formatRichText = (text) => {
  if (!text) {
    return '';
  }

  const links = [];

  const formatted = String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(URL_PATTERN, (match) => {
      const url = match.replace(URL_TRAILING_PATTERN, '');
      links.push(url);

      return `\uE000${links.length - 1}\uE000${match.slice(url.length)}`;
    })
    .replace(/\*\*\*(.+?)\*\*\*/g, '<strong><em>$1</em></strong>')
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    .replace(/_(.+?)_/g, '<u>$1</u>')
    .replace(/~(.+?)~/g, '<s>$1</s>')
    // Кілька пробілів поспіль (у т.ч. відступ на початку рядка) браузер схлопує — зберігаємо їх
    .replace(/ {2,}/g, (spaces) => `${'&nbsp;'.repeat(spaces.length - 1)} `);

  return TextFormatter().formatText(formatted).replace(LINK_PLACEHOLDER_PATTERN, (placeholder, index) => {
    const url = links[index];

    return `<a href="${url.replace(/"/g, '&quot;')}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });
};
